import { render, staticRenderFns } from "./addInvoiceModal.vue?vue&type=template&id=52141138&scoped=true&"
import script from "./addInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./addInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./addInvoiceModal.vue?vue&type=style&index=0&id=52141138&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52141138",
  null
  
)

export default component.exports